<template>
  <nav class="navbar navbar-expand-lg" :class="[$route.name == 'home' ? 'main-navbar navbar-dark':'navbar-light']">
    <span class="container">
      <router-link class="navbar-brand" to="/">
        <img :src="$route.name == 'home' ? require('../assets/images/logo-light.svg') : require('../assets/images/logo-dark.svg')" alt="">
      </router-link>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse mt-2" id="navbarSupportedContent">
        <ul class="navbar-nav m-auto">
          <li class="nav-item" :class="[$route.name == 'descubre'? 'active' : '']">
            <router-link class="nav-link" to="/descubre">Descubre</router-link>
          </li>
          <li class="nav-item" :class="[$route.name == 'participa'? 'active' : '']">
            <router-link class="nav-link" to="/participa">Participa</router-link>
          </li>
          <li class="nav-item" :class="[$route.name == 'regala'? 'active' : '']">
            <router-link class="nav-link" to="/regala">Regala</router-link>
          </li>
          <li class="nav-item" :class="[$route.name == 'estudia'? 'active' : '']">
            <router-link class="nav-link" to="/estudia">Estudia</router-link>
          </li>
          <li class="nav-item" :class="[$route.name == 'nosotros'? 'active' : '']">
            <router-link class="nav-link" to="/nosotros">Nosotros</router-link>
          </li>
          <li class="nav-item d-none d-sm-block">
            <a target="_blank" class="nav-link" href="#">
            </a>
          </li>
          <li class="nav-item">
            <div class="nav-link">
              <a target="_blank" href="https://apps.apple.com/il/app/jabrutouch/id1488439011">
                <i class="fab fa-apple"></i>
              </a>
              <a class="ml-3" target="_blank" href="https://play.google.com/store/apps/details?id=co.il.jabrutouch">
                <i class="fab fa-android"></i>
              </a>
            </div>
          </li>
        </ul>
      </div>
    </span>
  </nav>
</template>
<script>
export default {
  watch: {
    '$route' () {
      var el = document.getElementById('navbarSupportedContent').classList.remove("show")
      // el.classList.remove("show")
    }
  }
}

</script>
<style lang="scss">
@media (max-width:600px) {
  #navbarSupportedContent{
    height: 100vh;
  }
  .navbar-nav .nav-link{
    padding: 20px 15px!important;
    border-bottom: 1px solid #ddd;
    margin: 0 -15px;
    display: block;
    font-size: 20px;
    line-height: 24px;
    font-weight: normal;
  }
}
</style>